<template>
  <div>
    <v-card color="background" flat>
      <v-card-subtitle class="px-0 pb-0 caption">
        NUEVO CONTRATO
      </v-card-subtitle>

      <v-card-title class="px-0 pt-0 pb-5">
        Subí la documentación
      </v-card-title>

      <v-card-subtitle class="px-0 pb-1 caption"> </v-card-subtitle>
    </v-card>

    <v-card :loading="loading" :disabled="loading" class="fill-width">
      <v-card-text>
        <div class="pb-6">
          <v-form lazy-validation ref="form" v-model="valid">
            <div class="title black--text font-weight-regular">
              Contrato
            </div>

            <v-row v-if="fetchedContract.documents.length">
              <v-col class="pb-0" cols="6">
                <v-alert
                  v-if="contractFile"
                  class="white--text"
                  color="red lighten-2"
                >
                  Está reemplazando el archivo actual.
                </v-alert>
                <v-alert v-else class="white--text" color="info lighten-2">
                  Ya tiene un archivo de contrato cargado.
                </v-alert>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pt-0" cols="6">
                <v-file-input
                  filled
                  color="primary"
                  label="Contrato"
                  v-model="contractFile"
                  hint="*Obligatorio"
                  :rules="fetchedContract.documents.length ? [] : rules"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <div class="title black--text font-weight-regular">
              Garantes
            </div>
            <div :key="guarantee.id" v-for="guarantee in guarantees">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :items="contacts"
                    item-text="profile.name"
                    item-value="id"
                    v-model="guarantee.guarantorId"
                    filled
                    persistent-hint
                    label="Garante"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col class="mt-3" cols="6">
                  <v-dialog v-model="dialog" max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="blue lighten-1"
                        dark
                        text
                        v-bind="attrs"
                        v-on="on"
                      >
                        Agregar a agenda
                      </v-btn>
                    </template>

                    <NewContact
                      @close="dialog = false"
                      @created="onCreate(guarantor, $event)"
                    />
                  </v-dialog>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0" cols="6">
                  <v-file-input
                    filled
                    multiple
                    color="primary"
                    label="Fotos DNI"
                    v-model="guarantee.idCards"
                    persistent-hint
                  >
                  </v-file-input>
                </v-col>

                <v-col
                  v-if="
                    guarantee.guarantor &&
                      guarantee.guarantor.profile.documents.length
                  "
                  class="pt-0 d-flex flex-row"
                  cols="6"
                >
                  <v-card
                    :key="dni.id"
                    outlined
                    @click="openFile(dni)"
                    v-for="dni in guarantee.guarantor.profile.documents"
                  >
                    <v-card-text>
                      <v-icon>
                        mdi-file-image
                      </v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0 pb-1" cols="3">
                  <v-autocomplete
                    filled
                    label="Tipo garantía"
                    :items="['Propietaria', 'Laboral', 'Seguro de caución']"
                    v-model="guarantee.guaranteeType"
                    persistent-hint
                    color="primary"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col class="pl-0 pt-0 pb-1" cols="3">
                  <v-file-input
                    filled
                    label="Archivos"
                    multiple
                    v-model="guarantee.files"
                    color="primary"
                    persistent-hint
                  >
                  </v-file-input>
                </v-col>
              </v-row>

              <v-row class="d-flex flex-row" v-if="guarantee.documents">
                <v-col class="pt-0 pb-1" cols="12">
                  {{ guarantee.documents.length }} documentos cargados
                </v-col>
                <v-col
                  v-for="document in guarantee.documents"
                  :key="document.id"
                  class="pt-0 pr-0 shrink"
                >
                  <v-card @click="openFile(document)" outlined>
                    <v-card-text>
                      <v-icon>
                        mdi-file-pdf
                      </v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-row>
              <v-col class="pt-0 pb-1 text-right" cols="6">
                <v-btn text @click="pushGuarantee" color="blue lighten-1">
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
    </v-card>

    <div class="pt-6 text-right">
      <v-btn
        @click="$router.go(-1)"
        :loading="loading"
        :disabled="loading"
        text
      >
        Cerrar y continuar luego
      </v-btn>
      <v-btn
        :loading="loading"
        :disabled="loading"
        color="primary"
        @click="nextStep"
      >
        Siguiente
      </v-btn>
    </div>
  </div>
</template>

<script>
import UploadService from "@/services/uploadFiles";
import { mapGetters } from "vuex";

import Modal from "@/components/modals/Default";
import NewContact from "@/components/directories/New";
import { Contacts } from "@/graphql/queries/directory";
import { EditContract } from "@/graphql/mutations/contracts";

function comparer(otherArray) {
  return function(current) {
    return (
      otherArray.filter(function(other) {
        return other.name == current.name;
      }).length == 0
    );
  };
}

export default {
  data() {
    return {
      contract: {
        guaranteesAttributes: []
      },
      contractFile: null,
      guarantees: [
        {
          guarantorId: null,
          guaranteeType: null,
          files: [],
          idCards: []
        }
      ],
      fileRules: [
        v => !!v || "Archivo obligatorio",
        v => (v && v.length > 0) || "Archivo obligatorio"
      ],
      rules: [v => !!v || "Campo obligatorio"],
      contacts: [],
      valid: true,
      dialog: false,
      selectedFiles: [],
      message: "",
      progress: 0,
      uploaded: null,
      loaded: false,
      loading: false,
      images: []
    };
  },

  components: {
    Modal,
    NewContact
  },

  props: {
    fetchedContract: {
      type: Object,
      required: true
    }
  },

  mounted() {
    this.fetchContacts(true);
  },

  computed: {
    ...mapGetters(["url"])
  },

  methods: {
    fetchContacts(firstLoad = false) {
      this.$apollo
        .query({
          query: Contacts,
          variables: {
            noPaginate: true,
            notRoles: [],
            userId: (this.fetchedContract.tenant[0] || {}).id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.contacts = res.data.contacts.contacts;
          if (firstLoad) {
            this.fillData();
          }
        });
    },

    openFile(document) {
      window.open(this.url + document.url);
    },

    pushGuarantee() {
      this.guarantees.push({
        guarantorId: null,
        guaranteeType: null,
        files: []
      });
    },

    nextStep() {
      // this.$emit('continue', this.fetchedContract)
      if (this.valid) this.valid = this.$refs.form.validate();

      if (this.valid) {
        this.loading = true;

        this.mapContract();

        this.$apollo
          .mutate({
            mutation: EditContract,
            variables: {
              input: {
                attributes: this.contract,
                contractId: this.fetchedContract.id
              }
            }
          })
          .then(res => {
            var contract = res.data.editContract.contract;
            UploadService.upload(
              [this.contractFile],
              "Contract",
              this.fetchedContract.id,
              event => {
                console.log("event", event);
              }
            ).then(res => {
              var guarantees = contract.guarantees;

              if (this.guarantees.length && guarantees.length) {
                this.guarantees.forEach(guarantee => {
                  let id = guarantees.find(
                    g => g.guarantorId == guarantee.guarantorId
                  ).id;
                  UploadService.upload(
                    guarantee.files,
                    "Contracts::Guarantee",
                    id,
                    event => {
                      console.log("event", event);
                    }
                  ).then(res => {});

                  UploadService.upload(
                    guarantee.idCards,
                    "Users::Profile",
                    guarantee.guarantorId,
                    event => {
                      console.log("event", event);
                    }
                  ).then(res => {});
                });

                this.guarantees.forEach(guarantee => {
                  let id = guarantees.find(
                    g => g.guarantorId == guarantee.guarantorId
                  ).id;
                  UploadService.upload(
                    guarantee.files,
                    "Contracts::Guarantee",
                    id,
                    event => {
                      console.log("event", event);
                    }
                  ).then(res => {});
                });
              }

              this.$emit("continue", contract);

              this.loading = false;
            });
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      }
    },

    mapContract() {
      this.guarantees.forEach(guarantee => {
        if (guarantee.guarantorId && guarantee.guaranteeType) {
          this.contract.guaranteesAttributes.push({
            id: guarantee.id,
            guarantorId: guarantee.guarantorId,
            guaranteeType: guarantee.guaranteeType
          });
        }
      });
    },

    removeImage(idx) {
      this.selectedFiles.splice(idx, 1);
      this.images.splice(idx, 1);
      this.upload();
    },

    fillData() {
      if (this.fetchedContract.guarantees.length) {
        this.guarantees = this.fetchedContract.guarantees;
        this.guarantees.forEach(guarantee => {
          guarantee.files = [];
          guarantee.idCards = [];
        });
      }
    },

    onCreate(guarantee, newOwner) {
      this.fetchContacts();
      guarantee.guarantorId = newOwner.id;
      this.dialog = false;
    }
  }
};
</script>
